import React, { useCallback, useEffect, useState } from "react";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "react-final-form";
import Validator from "../../../../_helpers/validate.schema";
import { UiCol } from "../../../_uiComponents/grid-container/GridContainer";
import { UiCheckboxInput, UiInput, UiInputLink } from "../../../_uiComponents/form/UiInput";
import { getFingerPrint } from "../../../../_helpers/support.services";
import { UiButton, UiButtonPrimary } from "../../../_uiComponents/form/UiButton";
import { loginAuthRequest, profileNotificationChangeRequest } from "../../../../_redux/_actions";
import UiInlineSuccessMessage from "../../../_uiComponents/form/UiInlineSuccessMessage"

const validateSchema = () =>
    yup.object().shape({

    });

const onValidate = async (values) => {
    return await Validator(values, validateSchema);
};


export default function NotificationForm(props) {

    const actionDispatch = useDispatch();

    const [emailChecked, setEmailChecked] = useState(false);
    const [smsChecked, setSmsChecked] = useState(false);
    const [itemsArray, setItemsArray] = useState([]);

    useEffect(() => {
        if (props.preValues) {

            const { email, sms } = props.preValues;

            setEmailChecked(email);
            setSmsChecked(sms);

            const initialItems = [];
            if (email) {
                initialItems.push('email');
            }
            if (sms) {
                initialItems.push('sms');
            }
            setItemsArray(initialItems);

        }
    }, [props.preValues]);

    const selectTypes = (e) => {
        const { name, checked } = e.target;
        if (checked) {
            setItemsArray((prev) => [...prev, name]);
        } else {
            setItemsArray((prev) => prev.filter((item) => item !== name));
        }

        if (name === 'email') {
            setEmailChecked(checked);
        } else if (name === 'sms') {
            setSmsChecked(checked);
        }
    };

    const submit = async (values) => {
        const payload = {
            "inSystem": true,
            "email": emailChecked === undefined ? false : emailChecked,
            "sms": smsChecked === undefined ? false : smsChecked,
        }

        actionDispatch(profileNotificationChangeRequest(payload));
    };

    return (
        <Form
            onSubmit={submit}
            validate={onValidate}
            render={({ handleSubmit, hasValidationErrors }) => (
                <form onSubmit={validateSchema}>
                    <UiInlineSuccessMessage/>
                    <div className="sb-prof-expanded__my-network" >
                        <span className="sb-prof-network-sub-heading">You can manage your preferences to suit your needs.</span>
                        <span className="sb-prof-network-sub-heading">Select how you would like us to communicate with you.</span>
                        <UiCheckboxInput onChange={selectTypes} name="email" type="checkbox" label="Email" checked={emailChecked} />
                        <UiCheckboxInput onChange={selectTypes} name="sms" type="checkbox" label="Sms" checked={smsChecked} />
                        <UiCheckboxInput name="insystem" checked={true} type="checkbox" label="In-System" />

                        <div className="sb-prof-notification-btn">
                            <UiButtonPrimary
                                btnName={"Update"}
                                onClick={handleSubmit}
                            />
                        </div>
                    </div>
                </form>
            )}
        />
    );
}
